module.exports = __webpack_public_path__ + "static/media/YF78_4.1b38d48c.jpg";